import * as PIXI from 'pixi.js';
import { LayoutContainer } from '@pixi/layout/components'; // eslint-disable-line
import { CARD_WIDTH, CARD_HEIGHT } from '../../utils';
import TappableCard from './TappableCard';
import { BOTTOM_BAR_HEIGHT } from './BottomBar';

const GRID_COLUMNS = 3;
const CARD_GAP = 30;
const LIST_PADDING = 40;

function cardScale(listWidth) {
    const contentWidth = listWidth - LIST_PADDING * 2 - CARD_GAP * (GRID_COLUMNS - 1);
    return contentWidth / GRID_COLUMNS / CARD_WIDTH;
}

export default class CollectionCardsListContainer extends LayoutContainer {
    constructor(width, height) {
        super();

        this.label = 'collectionCardsListContainer';
        this.listWidth = width;
        this.listHeight = height;
        this.cards = [];
        this.emptySlots = [];
        this.layout = {
            width,
            height,
            flexDirection: 'row',
            alignContent: 'flex-start',
            overflow: 'scroll',
            gap: CARD_GAP,
            paddingTop: LIST_PADDING,
            paddingLeft: LIST_PADDING,
            paddingRight: LIST_PADDING,
            paddingBottom: BOTTOM_BAR_HEIGHT - LIST_PADDING,
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            backgroundColor: '#203250',
        };
    }

    resize(width, height) {
        if (this.listWidth === width && this.listHeight === height) return;
        this.listWidth = width;
        this.listHeight = height;
        this.layout.setStyle({
            width,
            height,
            paddingTop: LIST_PADDING,
            paddingLeft: LIST_PADDING,
            paddingRight: LIST_PADDING,
        });
        this.applyCardScale();
    }

    applyCardScale() {
        const scale = cardScale(this.listWidth);
        const width = CARD_WIDTH * scale;
        const height = CARD_HEIGHT * scale;
        for (const card of this.cards) {
            card.setScaleFactor(scale);
        }
        for (const slot of this.emptySlots) {
            slot.layout.setStyle({ width, height });
        }
    }

    setCards(cards) {
        this.removeChildren();
        this.cards = [];
        this.emptySlots = [];

        const scale = cardScale(this.listWidth);
        for (const card of cards) {
            const tappableCard = new TappableCard(card, {
                scaleFactor: scale,
                countersMode: 'collection',
                available: card.count || 0,
                showAsMissing: Boolean(card.missing),
            });
            tappableCard.onHeld = () => {
                this.onCardHeld?.(card);
            };
            this.cards.push(tappableCard);
            this.addChild(tappableCard);
        }

        const remainder = cards.length % GRID_COLUMNS;
        if (remainder !== 0) {
            const emptiesToAdd = GRID_COLUMNS - remainder;
            for (let i = 0; i < emptiesToAdd; i++) {
                const emptyCardSlot = new PIXI.Container();
                emptyCardSlot.label = 'emptyCardSlot';
                emptyCardSlot.layout = {
                    width: CARD_WIDTH * scale,
                    height: CARD_HEIGHT * scale,
                };
                this.emptySlots.push(emptyCardSlot);
                this.addChild(emptyCardSlot);
            }
        }

        if (this._trackpad?.yAxis) {
            this._trackpad.yAxis._hasStopped = false;
        }
    }
}
